import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONTACT_INFO, LOGO_URL } from "../data";

export default function Footer() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetch("https://api.dev.auxo.dk/public/content/services")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setServices(data);
        }
      })
      .catch((err) => console.error("Error fetching services for footer:", err));
  }, []);

  return (
    <footer className="bg-neutral-950 text-neutral-300 border-t border-neutral-800 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src={LOGO_URL}
                alt="JG Mesterbyg - Tømrermester i Erslev på Mors"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-neutral-400 leading-relaxed">
              Professionelt dansk tømrerarbejde på Mors og i hele Nordjylland. Vi bygger på kvalitet, tillid og godt håndværk.
            </p>
            <div className="flex gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-neutral-900 flex items-center justify-center text-neutral-400 hover:text-yellow-500 transition-all duration-200"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-neutral-900 flex items-center justify-center text-neutral-400 hover:text-yellow-500 transition-all duration-200"
                aria-label="Instagram"
              >
                <i className="fa-brands fa-instagram" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-bold text-base mb-6 flex items-center gap-2">
              <span className="w-1.5 h-4 bg-yellow-500 rounded-full" />
              Ydelser
            </h4>
            <ul className="space-y-3 text-sm">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/ydelser/${service.slug._ || service.slug}`}
                    className="hover:text-yellow-500 transition-colors duration-150 flex items-center gap-2"
                  >
                    <i className="fa-solid fa-chevron-right text-[10px] text-yellow-500" />
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white font-bold text-base mb-6 flex items-center gap-2">
              <span className="w-1.5 h-4 bg-yellow-500 rounded-full" />
              Hurtige links
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-yellow-500 transition-colors duration-150 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-yellow-500" />
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-yellow-500 transition-colors duration-150 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-yellow-500" />
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-yellow-500 transition-colors duration-150 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-yellow-500" />
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/fa-tilbud" className="hover:text-yellow-500 transition-colors duration-150 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-yellow-500" />
                  Få uforpligtende tilbud
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-bold text-base mb-6 flex items-center gap-2">
              <span className="w-1.5 h-4 bg-yellow-500 rounded-full" />
              Kontaktinfo
            </h4>
            <ul className="space-y-4 text-sm text-neutral-400">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-yellow-500 mt-1 text-base" />
                <span>
                  <strong className="text-white block">JG Mesterbyg</strong>
                  {CONTACT_INFO.address}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-yellow-500 text-base" />
                <span className="whitespace-nowrap">
                  Tlf: <a href={`tel:${CONTACT_INFO.phone}`} className="text-white hover:text-yellow-500 transition-colors whitespace-nowrap">{CONTACT_INFO.phoneDisplay}</a>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-yellow-500 text-base" />
                <span className="whitespace-nowrap">
                  E-mail: <a href={`mailto:${CONTACT_INFO.email}`} className="text-white hover:text-yellow-500 transition-colors whitespace-nowrap">{CONTACT_INFO.email}</a>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-id-card text-yellow-500 text-base" />
                <span>
                  CVR: <span className="text-white">{CONTACT_INFO.cvr}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-neutral-800 text-center text-xs text-neutral-500 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p>© {new Date().getFullYear()} JG Mesterbyg. Alle rettigheder forbeholdes.</p>
          <p>
            Designet af <a href="https://auxo.dk" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-500 transition-colors underline underline-offset-2">Auxo</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
